<!-- 由 suu 创建于 2021-08-11 星期三 -->
<template>
  <div class="About u-text-center">
    <vLoading></vLoading>
    <!-- <img
      class="loadings"
      src="https://cdnvue.gymcity.com.cn/uploads/loading-member"
    /> -->
    <!-- <v-svg icon="iconwifi"></v-svg> -->
  </div>
</template>

<script>
export default {
  name: 'About',

  components: {},

  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.About {
  width: 100vw;
  min-height: 100vh;
  @include flex-c;
  justify-content: center;
  .loadings {
    width: vw(250);
  }
}
</style>
